import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface Props {
  title: string;
  desc: string;
  icon: string;
  list: Comic[];
  linkText: string;
  linkTo: string;
  rank?: boolean;
  bg?: 'light' | 'tint';
}

export default function ComicSection({ title, desc, icon, list, linkText, linkTo, rank, bg = 'light' }: Props) {
  return (
    <section className={`${bg === 'tint' ? 'bg-background-100' : ''} py-12 md:py-16`}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className={icon}></i> 精选推荐
            </p>
            <h2 className="mt-1 font-display text-2xl text-foreground-900 md:text-3xl">{title}</h2>
            <p className="mt-2 text-sm text-foreground-600">{desc}</p>
          </div>
          <Link to={linkTo} className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap">
            {linkText} <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
          {list.slice(0, 10).map((comic, i) => (
            <ComicCard key={comic.id} comic={comic} rank={rank ? i + 1 : undefined} />
          ))}
        </div>
      </div>
    </section>
  );
}